import { useState, useEffect } from "react";
import firebase from "firebase/compat/app";

import { Challenge } from "../types/challengeDataResponse";
import { brand } from "../brandVariables/getBandVariables";

export const useCurrentEventChallenges = () => {
  const [loadingNextChallenge, setLoadingNextChallenge] = useState(true);
  const [nextChallenges, setNextChallenges] = useState<Challenge[] | null>(
    null
  );
  const [loadingOngoingChallenge, setLoadingOngoingChallenge] = useState(true);
  const [ongoingChallenge, setOngoingChallenge] = useState<Challenge | null>(
    null
  );

  const upComingChallengesQuery = firebase
    .firestore()
    .collection("challenges")
    .where("client", "==", brand.client)
    .where("gameType", "==", brand.challengeGameType)
    .where("status", "==", "upcoming");

  const ongoingChallengesQuery = firebase
    .firestore()
    .collection("challenges")
    // .where("client", "==", brand.client)
    // .where("gameType", "==", brand.challengeGameType)
    // .where("status", "==", "ongoing")
    .where("slug", "==", "cs2-time-trial-test-april")
    .limit(1);

  const fetchUpcomingData = async () => {
    try {
      setLoadingNextChallenge(true);

      upComingChallengesQuery.onSnapshot((snapshotForUpcoming) => {
        if (snapshotForUpcoming.docs.length > 0) {
          const upcomingChallengesData = snapshotForUpcoming.docs.map((doc) => {
            return doc.data();
          }) as Challenge[];

          upcomingChallengesData.sort((a, b) => {
            return a.startDate.seconds * 1000 - b.startDate.seconds * 1000;
          });

          setNextChallenges(upcomingChallengesData);
        }
        setLoadingNextChallenge(false);
      });
    } catch (error) {
      setLoadingNextChallenge(false);
    } finally {
      setLoadingNextChallenge(false);
    }
  };

  const fetchOngoingData = async () => {
    try {
      setLoadingOngoingChallenge(true);
      ongoingChallengesQuery.onSnapshot((snapshotForOngoing) => {
        const challenge = snapshotForOngoing.docs.map((doc) => doc.data())[0];

        if (challenge) {
          // @ts-ignore
          setOngoingChallenge(challenge);
        } else {
          setOngoingChallenge(undefined);
        }
        setLoadingOngoingChallenge(false);
      });
    } catch (error) {
      setLoadingOngoingChallenge(false);
    } finally {
      setLoadingOngoingChallenge(false);
    }
  };

  // Check if its init run/data connection has already been initialized
  useEffect(() => {
    fetchUpcomingData();
  }, []);

  useEffect(() => {
    fetchOngoingData();
  }, []);

  console.log({ nextChallenges });
  console.log({ ongoingChallenge });

  return {
    fetchUpcomingData,
    loadingNextChallenge,
    nextChallenges,
    fetchOngoingData,
    loadingOngoingChallenge,
    ongoingChallenge,
  };
};
